<section class="contact-hero">

    <div class="hero-overlay"></div>

    <div class="hero-content">

        <div class="hero-left">

         <h1>
                KONTAKTIRAJTE <span>NAS</span>
            </h1>

            <p>
                Bilo da imate gotovu ideju ili vam je potrebna pomoć pri odabiru modela i dizajna, naš tim je tu da zajedno pronađemo najbolje rešenje za vaše potrebe.
            </p>

            <div class="features">

                <div class="feature">
                    <i class="fa-regular fa-comments"></i>
                    <h4>Savet i podrška</h4>                 
                </div>

                <div class="feature">
                    <i class="fa-solid fa-shield"></i>
                    <h4>Pouzdan partner</h4>                
                </div>

                <div class="feature">
                    <i class="fa-solid fa-shirt"></i>
                    <h4>Potpuna personalizacija</h4>              
                </div>

                <div class="feature">
                    <i class="fa-solid fa-users"></i>
                    <h4>Stručna podrška</h4>            
                </div>

            </div>

        </div>

        <div class="hero-right">
            

        </div>

    </div>

</section>

<section class="contact-section">

    <div class="contact-wrapper">

        <!-- FORM -->

    <!-- FORM -->

<div class="contact-form">

    <h2>Opišite šta vam je potrebno</h2>

    <form (ngSubmit)="sendMessage()">

        <div class="form-group">

            <label>Ime i prezime</label>

            <input
                type="text"
                name="name"
                [(ngModel)]="form.name"
                placeholder="Unesite ime i prezime"
                required>

        </div>


        <div class="form-group">

            <label>Email</label>

            <input
                type="email"
                name="email"
                [(ngModel)]="form.email"
                placeholder="Unesite email adresu"
                required>

        </div>


        <div class="form-group">

            <label>Telefon</label>

            <input
                type="text"
                name="phone"
                [(ngModel)]="form.phone"
                placeholder="Unesite broj telefona">

        </div>


        <div class="form-group">

            <label>Predmet</label>

            <select
                name="subject"
                [(ngModel)]="form.subject"
                required>

                <option value="">
                    Izaberite temu
                </option>

                <option value="Narudžbina">
                    Narudžbina
                </option>

                <option value="Ponuda">
                    Ponuda
                </option>

                <option value="Generalno pitanje">
                    Generalno pitanje
                </option>

                <option value="Ostalo">
                    Ostalo
                </option>

            </select>

        </div>


        <div class="form-group">

            <label>Poruka</label>

            <textarea
                name="message"
                [(ngModel)]="form.message"
                rows="7"
                placeholder="Napišite svoju poruku..."
                required>
            </textarea>

        </div>


        <button
            type="submit"
            class="btn-send"
            [disabled]="sending">

            {{ sending
                ? 'SLANJE...'
                : 'POŠALJI PORUKU'
            }}

        </button>


        <!-- SUCCESS -->

        <div
            class="success-message"
            *ngIf="sent">

            <i class="fa-solid fa-circle-check"></i>

            Poruka je uspešno poslata.
            Javićemo vam se u najkraćem roku.

        </div>


        <!-- ERROR -->

        <div
            class="error-message"
            *ngIf="error">

            <i class="fa-solid fa-circle-exclamation"></i>

            Došlo je do greške prilikom slanja.
            Pokušajte ponovo.

        </div>

    </form>

</div>

        <!-- INFO -->

        <div class="contact-info">

            <h2>KONTAKT INFORMACIJE</h2>

            <div class="info-item">

                <i class="fa-solid fa-phone"></i>

                <div>

                    <span>Telefon</span>

                    <p>069 13 23 911,
                       062 218 400</p>

                </div>

            </div>

            <div class="info-item">

                <i class="fa-solid fa-envelope"></i>

                <div>

                    <span>Email</span>

                    <p>lazzarosportskaoprema@gmail.com</p>

                </div>

            </div>

            <div class="info-item">

                <i class="fa-solid fa-location-dot"></i>

                <div>
                    <span>Adresa</span>
                    <p>ILIJE GOJKOVIĆA 9</p>
                    <p>Požarevac, Srbija </p>
                </div>

            </div>

            <!-- GOOGLE MAPS PREVIEW -->
            <div class="map-preview">
                <iframe
                    src="https://maps.google.com/maps?q=44.6154461,21.1694588&z=17&output=embed"
                    width="100%"
                    height="240"
                    style="border:0;"
                    loading="lazy"
                    allowfullscreen
                    referrerpolicy="no-referrer-when-downgrade"
                    title="Lazzaro proizvodnja sportske opreme - Google Maps">
                </iframe>

                
            </div>

            <div class="info-item">

                <i class="fa-regular fa-clock"></i>

                <div>

                    <span>Radno vreme</span>

                    <p>Ponedeljak - Petak</p>

                    <strong>08:00 - 15:00</strong>

                    <p>Subota</p>

                    <strong>08:00 - 14:00</strong>
                </div>

            </div>

<div class="upload-card">

    <div class="upload-left">

        <h3>Dodajte fajl</h3>

        <p>
            Imate gotov dizajn ili ideju?
            Pošaljite nam fajl i dobićete ponudu.
        </p>

    </div>


    <div class="upload-right">

        <i class="fa-solid fa-cloud-arrow-up"></i>

        <p>
            {{ selectedFile
                ? selectedFile.name
                : 'Dodajte fajl'
            }}
        </p>

        <span>
            PDF, AI, PSD, PNG, JPG
        </span>

        <strong>
            max 20 MB
        </strong>

    </div>


    <!-- DUGME NA DNU -->

    <label
        for="file-upload"
        class="upload-btn">

        {{ selectedFile
            ? 'Fajl izabran'
            : 'Izaberi fajl'
        }}

    </label>

    <input
        id="file-upload"
        type="file"
        hidden
        accept=".pdf,.ai,.psd,.png,.jpg,.jpeg"
        (change)="onFileSelected($event)">

</div>

         
        </div>

    </div>

</section>